import * as React from 'react';
import { DropTarget } from 'react-dnd';

class DraggableTarget extends React.PureComponent {
  useCallback = (cb) => (e) => {
    const { srcItemType, targetItemTypes } = this.props;
    if (cb && targetItemTypes.includes(srcItemType)) {
      cb(e, srcItemType);
    }
  };

  render() {
    const { onDragEnter, onDragLeave, onDragOver, className, children, connectDropTarget, style, refProxy } =
      this.props;

    return connectDropTarget(
      <div
        onDragEnter={this.useCallback(onDragEnter)}
        onDragLeave={this.useCallback(onDragLeave)}
        // need for firefox
        onDragOver={this.useCallback(onDragOver)}
        className={className}
        ref={refProxy}
        style={style}
      >
        {children}
      </div>,
    );
  }
}

const dropSource = {
  drop(props, monitor) {
    if (!monitor.getItem().files && !monitor.didDrop() && props.onDndDrop) {
      props.onDndDrop(monitor.getItem());
    }
  },
};

const collect = (types) => (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  srcItemType: monitor.getItemType(),
  targetItemTypes: Array.isArray(types) ? types : [types],
});

export const DnDItemTarget = (name) => DropTarget(name, dropSource, collect(name))(DraggableTarget);
